import {
  Button,
  Card,
  Checkbox,
  Form,
  Icons,
  Input,
  Select,
  Space,
  Typography,
} from '@pankod/refine-antd';
import { useState } from 'react';

type TypesFormListProps = { name: string; required?: boolean };

export const TypesFormList: React.FC<TypesFormListProps> = ({ name, required = true }) => {
  const [dropdownKeys, setDropDownKeys] = useState<number[]>([]);

  const rules = [];
  if (required) {
    rules.push({
      validator: async (_: any, attributes: any) => {
        if (!attributes.length) {
          return Promise.reject(new Error('at least one attribute is required'));
        }
      },
    });
  }

  return (
    <Form.List
      name={name}
      initialValue={[
        {
          type: 'Text',
          options: [],
          required: false,
          allowCustomValue: false,
          name: null,
        },
      ]}
      rules={rules}
    >
      {(fields, { add, remove }, { errors }) => (
        <>
          {fields.map(({ key, name, ...restField }, index) => {
            const attributeCardTitle = (
              <div
                style={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  alignItems: 'center',
                }}
              >
                <Typography.Text>Attribute {index + 1}</Typography.Text>
                <Icons.MinusCircleOutlined onClick={() => remove(name)} style={{ color: 'red' }} />
              </div>
            );

            return (
              <Card key={key} title={attributeCardTitle} style={{ flex: 1, marginBottom: '20px' }}>
                <Form.Item
                  {...restField}
                  name={[name, 'type']}
                  rules={[{ required: true, message: "attribute 'type' missing" }]}
                  initialValue={'Text'}
                >
                  <Select
                    style={{ width: '100%' }}
                    onChange={(value) => {
                      if (value === 'Dropdown') {
                        return setDropDownKeys((state) => state.concat(key));
                      }
                      setDropDownKeys((state) => state.filter((value) => value !== key));
                    }}
                  >
                    <Select.Option key={0} value="Text">
                      <Space align="center">
                        <Icons.FileTextOutlined /> Text
                      </Space>
                    </Select.Option>
                    <Select.Option key={1} value="Float">
                      <Space align="center">
                        <Icons.NumberOutlined /> Number
                      </Space>
                    </Select.Option>
                    <Select.Option key={2} value="Boolean">
                      <Space align="center">
                        <Icons.CheckCircleOutlined /> Boolean
                      </Space>
                    </Select.Option>
                    <Select.Option key={3} value="Dropdown">
                      <Space align="center">
                        <Icons.UnorderedListOutlined /> Dropdown
                      </Space>
                    </Select.Option>
                  </Select>
                </Form.Item>
                <Form.Item
                  {...restField}
                  name={[name, 'name']}
                  rules={[{ required: true, message: "attribute 'name' missing" }]}
                >
                  <Input placeholder="Name" />
                </Form.Item>
                <Form.Item
                  {...restField}
                  name={[name, 'options']}
                  hidden={!dropdownKeys.includes(key)}
                  initialValue={[]}
                >
                  <Select mode="tags" placeholder="options" style={{ width: '100%' }} />
                </Form.Item>

                <Space>
                  <Form.Item
                    {...restField}
                    name={[name, 'required']}
                    valuePropName="checked"
                    initialValue={false}
                  >
                    <Checkbox>Required</Checkbox>
                  </Form.Item>
                  <Form.Item
                    {...restField}
                    name={[name, 'allowCustomValue']}
                    valuePropName="checked"
                    initialValue={false}
                    hidden={!dropdownKeys.includes(key)}
                  >
                    <Checkbox>Custom value</Checkbox>
                  </Form.Item>
                </Space>
              </Card>
            );
          })}
          <Form.Item>
            <Button type="dashed" onClick={() => add()} block icon={<Icons.PlusOutlined />}>
              Add attribute
            </Button>
            <Form.ErrorList errors={errors} />
          </Form.Item>
        </>
      )}
    </Form.List>
  );
};
